import { render } from "./GroupRanking.vue?vue&type=template&id=0b477386&scoped=true&ts=true"
import script from "./GroupRanking.vue?vue&type=script&lang=ts"
export * from "./GroupRanking.vue?vue&type=script&lang=ts"

import "./GroupRanking.vue?vue&type=style&index=0&id=0b477386&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src669166032/src/hackingclub-spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b477386"]])

export default __exports__